module.exports = __webpack_public_path__ + "media/hero_simple-celebration-03.d75d063c.mp3";